import { Alert, Button, Icon, Modal } from 'antd';
import { FormComponentProps } from "antd/lib/form";
import React, { FormEvent, useRef, useState } from 'react';
import { endAgreementEarly } from 'src/apis/AclManagement';
import EndAgreementForm from './EndAgreementForm';

interface ILocalProps {
    agreementID: number;
    requestClose: () => void;
}

const EndAgreementModal: React.FC<ILocalProps> = (props) => {
    const [submitting, setSubmitting] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [responseMessage, setResponseMessage] = useState('');

    const formRef = useRef<any>(null);

    const handleClose = (e: React.MouseEvent) => {
        e.preventDefault();
        props.requestClose();
    };
    const handleSubmit = () => {
        const { agreementID } = props;

        const formProps: FormComponentProps = formRef.current!.props;
        const { form } = formProps;

        form.validateFields(async (err, values) => {
            if (err) {
                return;
            }
            setSubmitting(true);

            try {
                const response = await endAgreementEarly(agreementID, values.notes);
                setResponseMessage(response.error ?? '');
                if (response.success) {
                    // Reload the whole page to update state!
                    window.location.reload();
                }
            } catch (e) {
                setResponseMessage('Error ending the commitment. Please report this issue.');
            }
            setSubmitting(false);
        });
    };
    const handleValidate = (e: FormEvent<HTMLFormElement>) => {
        const formProps: FormComponentProps = formRef.current!.props;
        const { form } = formProps;
        const fieldTouched = form.isFieldsTouched();
        let hasFieldErrors = false;
        const errors = form.getFieldsError();

        for (const key in errors) {
            hasFieldErrors = hasFieldErrors || errors[key] !== undefined;
        }

        setDisableSubmit(!fieldTouched || hasFieldErrors);
    }

    return (
      <Modal
        closable={false}
        title={
            <div>
                <Icon type="warning" theme="twoTone" twoToneColor="#F14A32"/>
                <b>You are about to cancel an agreement!</b>
            </div>
        }
        visible={true}
        footer={[
            <div key="footerContainer">
                <Button key="close" onClick={handleClose}>Cancel</Button>
                <Button
                    type='primary'
                    loading={submitting}
                    onClick={handleSubmit}
                    disabled={disableSubmit}
                >
                    Submit
                </Button>
            </div>
        ]}
      >
        <div>Please provide a cancellation reason in the box below.</div><br/>
        <EndAgreementForm onChange={handleValidate} wrappedComponentRef={formRef} />
        {responseMessage !== '' &&
            <Alert message={responseMessage} type={'error'} />
        }
      </Modal>
    );
}

export default EndAgreementModal;
